import React from 'react';
import DefaultButton from 'components/common/DefaultButton';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';

/**
 * 인증 전송 버튼 컴포넌트의 Props 인터페이스
 * @property {string} authSendButtonTitle - 버튼 제목
 * @property {boolean} authed - 인증 여부
 * @property {() => void} onclick - 클릭 이벤트 핸들러
 */
interface Props {
  authSendButtonTitle: string;
  authed: boolean;
  onclick: () => void;
}

/**
 * 인증 전송 버튼 컴포넌트
 * 인증 코드를 전송하는 버튼 컴포넌트입니다.
 * @param {Props} props - 인증 전송 버튼 컴포넌트의 props
 * @returns {JSX.Element} 인증 전송 버튼 컴포넌트
 */
export default function AuthSendButton({
  authSendButtonTitle,
  authed,
  onclick,
}: Props) {
  return (
    <DefaultButton
      text={authSendButtonTitle}
      buttonStyle={{
        width: minmax(172),

        backgroundColor:
          authSendButtonTitle === 'reSendAuth'
            ? colors.borderGray
            : authed
            ? colors.darkGray
            : colors.lighterGray,
      }}
      textStyle={{
        color:
          authSendButtonTitle === 'reSendAuth'
            ? colors.white
            : authed
            ? colors.white
            : colors.borderGray,
        fontSize: minmax(20),
      }}
      onClick={onclick}
    />
  );
}
